import {Injectable} from "@angular/core";
import {environment} from '../../environments/environment';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {
  CampaignRootPayloadModelList,
  CreateCampaignPayloadModel,
  GetAllCampaignPayloadModel, UpdateCampaignPayloadModel
} from './campaign_interfaces';






@Injectable({providedIn: 'root'})
export class CampaignService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {} //end constructor

  gets(endpoint: string, is_mocked: boolean = false): Observable<GetAllCampaignPayloadModel[]> {

    // if (is_mocked) {
    //   // return of<GetAllCampaignPayloadModel[]>(
    //   //     [
    //   //       {
    //   //         "campaign_id": "1",
    //   //         "name": "Mock Client",
    //   //       }
    //   //   ]
    //   // )
    // } // end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllCampaignPayloadModel[]>(url);
  } // end gets

  get(endpoint: string, is_mocked: boolean = false): Observable<GetAllCampaignPayloadModel> {

    if(is_mocked) {
      return of<GetAllCampaignPayloadModel>(

        // {
        //   "campaign_id": "1",
        //   "name": "Mock Client"
        // }

      )
    } //end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllCampaignPayloadModel>(url);

  } //end gets

  post(endpoint: string, data:  CreateCampaignPayloadModel){
    return this.http.post<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end post

  put(endpoint: string, data:  UpdateCampaignPayloadModel){
    return this.http.put(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end put

  delete(endpoint: string){
    let url = `${this.url}/${endpoint}`;
    return this.http.delete(url);
  } //end login




} //end CampaignService
